<template>
  <!-- 登录组件 -->
  <div class='login'>
    <div v-loading='loading' class='content'>
      <div class='header'>
        <span :class='{"active":memberType==="MEMBER"}' @click='toggleMemberType("MEMBER")'>会员登录</span>
        <!-- <span :class='{"active":memberType==="ADMIN"}' @click='toggleMemberType("ADMIN")'>管理员登录</span> -->
      </div>
      <div class='input-wrapper'>
        <input v-model='phone' type='tel' class='input' placeholder='请输入手机号码' @keyup.enter='login'>
        <input v-model='pwd' type='password' class='input' placeholder='请输入密码' @keyup.enter='login'>
      </div>
      <div v-if='memberType==="MEMBER"' class='nav-bar'>
        <div class='checkbox-wrapper'>
          <input id='checkbox' v-model='isRememberPwd' type='checkbox' class='checkbox'>
          <label for='checkbox'>记住密码</label>
        </div>
        <div class='register-wrapper'>
          <a href='javascript:;' class='register' @click='resetPwdHanlder'>忘记密码</a> | <a href='javascript:;' class='register' @click='registerHandler'>注册</a>
        </div>
      </div>
      <div class='btn-wrapper'>
        <a href='javascript:;' class='btn-login' @click='login'>登录</a>
        <a href='javascript:;' class='btn-cancel' @click='goBack'>取消</a>
      </div>
      <div v-if='memberType==="MEMBER"' class='login-third-way' @click='wechatLogin'>
        <span>第三方账号登录</span>
        <img src='../assets/imgs/wechat_login.png' alt='' class='icon-login-wechat'>
      </div>
      <div v-show='showLoginBox' class='wechat-login-box-wrapper'>
        <div class='img-wrapper' @click='close'>
          <img src='../assets/imgs/close_red.png' alt='' class='close'>
        </div>
        <div id='wechatLoginBox' class='login-box'/>
      </div>
    </div>
  </div>
</template>

<script>
import { LOGIN_MEMBER, LOGIN_ADMIN } from '@/api'

export default {
  data() {
    return {
      loading: false,
      phone: '',
      pwd: '',
      isRememberPwd: true,
      memberType: 'MEMBER',
      showLoginBox: false,
    }
  },
  created() {
    this.checkAccountInfo()
  },

  methods: {
    // 显示重置密码
    resetPwdHanlder() {
      this.$emit('resetPwd')
    },

    // 注册
    registerHandler() {
      this.$emit('register')
    },

    // 关闭扫码
    close() {
      this.showLoginBox = false
    },

    // 微信扫码登录
    wechatLogin() {
      this.showLoginBox = true
      var obj = new WxLogin({
        self_redirect: false,
        id: 'wechatLoginBox', 
        appid: 'wx97d0fee4ea9263ca', 
        scope: 'snsapi_login', 
        redirect_uri: encodeURI('http://wtjccs.hxtjh.com/client/oauth/wx_h5_login_callback'),
        state: '',
        style: '',
        href: ''
      })
    },
        
    // 切换 会员 管理员
    toggleMemberType(val) {
      this.memberType = val
    },

    // 登录
    login() {
      if (!(/^1[3-9][0-9]{9}$/.test(this.phone))) {
        this.$notify('请输入正确手机号','warning')
        return
      }
      if ((this.pwd + '').length < 6) {
        this.$notify('请输入不少于6位密码','warning')
        return
      }
      let para = {
        phone: this.phone,
        password: this.pwd
      }

      if (this.memberType === 'MEMBER') this.submitLoginMember(para)
      else this.submitLoginAdmin(para)
    },

    // 提交会员登录
    submitLoginMember(para) {
      this.loading = true
      LOGIN_MEMBER(para).then(res=>{
        this.loading = false
        if (res.data.code === 0) {
          this.$notify('登录成功')
          this.storeToken(res.data.data.token)
          this.storeMemberType()
          this.setRememberPwd()
          this.$emit('success')
        } else {
          this.$notify(res.data.msg,'error')
        }
      })
    },

    // 提交管理员登录
    submitLoginAdmin(para) {
      this.loading = true
      LOGIN_ADMIN(para).then(res=>{
        this.loading = false
        if (res.data.code === 0) {
          this.$notify('登录成功')
          this.storeToken(res.data.data.token)
          this.storeMemberType()
          this.$emit('success')
        } else {
          this.$notify(res.data.msg,'error')
        }
      })
    },

    storeMemberType() {
      let payload = {
        key: 'memberType',
        val: this.memberType
      }
      this.$store.commit('updateStrData',payload)
    },

    // 记住密码
    setRememberPwd() {
      localStorage.setItem('WAITU_IS_REMEMBER_PWD',this.isRememberPwd)
      if (this.isRememberPwd) {
        let accountInfo = {
          phone: this.phone,
          pwd: this.pwd
        }
        localStorage.setItem('WAITU_ACCOUNT_INFO',JSON.stringify(accountInfo))
      } else {
        localStorage.removeItem('WAITU_ACCOUNT_INFO')
      }
    },           
        
    // 检测账号信息
    checkAccountInfo() {
      let isRememberPwd = localStorage.getItem('WAITU_IS_REMEMBER_PWD')
      this.isRememberPwd = isRememberPwd ? isRememberPwd : false
      if (this.isRememberPwd) {
        let accountInfo = localStorage.getItem('WAITU_ACCOUNT_INFO')
        if (accountInfo) {
          let info = JSON.parse(accountInfo)
          this.phone = info.phone
          this.pwd = info.pwd
        }
      } else {
        this.phone = ''
        this.pwd = ''
      }
    },

  },
}
</script>

<style lang="less" scoped>
@import "../assets/css/mixin.less";

.login {
  min-width: 1200px;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.7);

  .content {
    width: 500px;
    height: 420px;
    box-sizing: border-box;
    background-color: #fff;
    margin-left: -250px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.8);
    border-radius: 5px;
    position: relative;
    margin: 150px auto 0;

    .header {
      width: 500px;
      height: 46px;
      line-height: 46px;
      font-size: 20px;
      display: flex;
      flex-direction: row;
      align-items: center;
      cursor: pointer;

      span {
        display: inline-block;
        flex: 1;
        text-align: center;
        color: #999;

        &:nth-child(1) {
          border-top-left-radius: 5px;
        }
        &:nth-child(2) {
          border-top-right-radius: 5px;
        }

        &.active {
          color: #fff;
          background-color: @blue-d;
        }
      }
    }

    .input-wrapper {
      width: 310px;
      margin: 30px auto 0;

      .input {
        height: 40px;
        width: 310px;
        box-sizing: border-box;
        padding: 0 5px;
        border: 1px solid #ddd;
        border-radius: 3px;
        font-size: 16px;
        outline: none;
        margin-bottom: 20px;
      }
    }

    .nav-bar {
      height: 20px;
      width: 310px;
      margin: 0 auto;
      line-height: 20px;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      font-size: 13px;
      color: @blue-d;

      .checkbox-wrapper {
        label {
          cursor: pointer;
          font-size: 12px;
        }
        input[type="checkbox"] {
          -webkit-appearance: checkbox;
          box-sizing: border-box;
          cursor: pointer;
        }
      }

      .register-wrapper {
        a {
          color: @blue-d;
        }
      }
    }

    .btn-wrapper {
      width: 310px;
      margin: 25px auto 0;

      a {
        display: block;
        width: 310px;
        height: 38px;
        line-height: 38px;
        font-size: 20px;
        border-radius: 5px;
        color: #fff;
        text-align: center;
        margin-bottom: 15px;

        &.btn-login {
          background: @blue-d;
        }

        &.btn-cancel {
          background: #ccc;
        }
      }
    }

    .login-third-way {
      width: 310px;
      height: 28px;
      color: #4d4d4d;
      font-size: 12px;
      cursor: pointer;
      margin: 0 auto;

      .icon-login-wechat {
        width: 28px;
        height: 24px;
        vertical-align: middle;
        padding-bottom: 5px;
      }
    }

    .wechat-login-box-wrapper {
      width: 500px;
      height: 420px;
      position: absolute;
      top: 0;
      left: 0;
      background-color: #fff;
      border-radius: 5px;

      .img-wrapper {
        width: 50px;
        height: 50px;
        z-index: 999;
        position: absolute;
        top: 0;
        right: 0;
        cursor: pointer;
        box-sizing: border-box;
        padding-top: 10px;
        padding-left: 20px;

        img {
          width: 18px;
          height: 18px;
        }
      }

      .login-box {
        width: 500px;
        height: 420px;
        position: absolute;
        top: 0;
        left: 0;
        background-color: #fff;
        display: flex;
        flex-direction: column;
        align-items: center;
        border-radius: 15px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Login.vue